import { signal } from '@preact/signals-react'

export const utgListSignal = signal([])
export const utgListLoadingSignal = signal(false)
export const utgListErrorSignal = signal(null)